import { Helmet } from 'react-helmet';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import Services from './components/Services';

function Main() {
  return (
    <div>
      <Helmet>
        <title>Shrikant Tally Institute Damoh | Best Tally Course | Shrikant Singhai</title>
        <meta name="description" content="Shrikant Tally Institute Damoh – founded by Shrikant Singhai. Best Tally training center in Damoh MP. Tally Professional, GST, TDS courses with 100% placement support. ISO 9001:2015 certified & Tally Education authorized partner since 2007." />
        <meta name="keywords" content="Shrikant Tally Institute, Shrikant Tally, Shrikant Singhai, Shrikant Singhai Damoh, Shrikant tally institute Damoh, shrikant takkt institute, best Tally institute Damoh, best Tally institute MP, best accounting institute Damoh, Tally course Damoh, Tally training Damoh, Tally institute near me, Tally Professional course, Tally Expert course, GST course Damoh, TallyPrime training Damoh, accounting course Damoh, accounting institute Madhya Pradesh, Tally Education partner Damoh, Tally certification Damoh, job placement Tally Damoh, Tally institute Purana Thana, Damoh accounting classes, tally damoh, tally classes damoh, tally coaching damoh, tally computer course damoh, best tally institute, tally course near me, tally prime course, accounting classes near me, GST training Damoh, TDS course Damoh, payroll course Damoh" />
        <meta property="og:title" content="Shrikant Tally Institute Damoh | Best Tally Course by Shrikant Singhai" />
        <meta property="og:description" content="Join Shrikant Tally Institute – Damoh's #1 Tally training center by Shrikant Singhai. Tally Professional, GST, TDS courses with guaranteed placement. ISO certified since 2007." />
        <meta property="og:url" content="https://shrikanttallyinstitute.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://shrikanttallyinstitute.com/tally.png" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Shrikant Singhai" />
        <meta name="geo.region" content="IN-MP" />
        <meta name="geo.placename" content="Damoh, Madhya Pradesh" />
        <meta name="geo.position" content="23.8360413;79.444489" />
        <meta name="ICBM" content="23.8360413, 79.444489" />
        <link rel="canonical" href="https://shrikanttallyinstitute.com/" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "EducationalOrganization",
            "name": "Shrikant Tally Institute",
            "alternateName": ["Shrikant Tally", "Shrikant Singhai Tally Institute", "Best Tally Institute Damoh", "Shrikant Takkt Institute"],
            "url": "https://shrikanttallyinstitute.com",
            "logo": "https://shrikanttallyinstitute.com/tally.png",
            "image": "https://shrikanttallyinstitute.com/tally.png",
            "description": "Best Tally training institute in Damoh MP. Founded by Shrikant Singhai in 2007. Offering Tally Professional, GST, TDS, Payroll courses with placement support. ISO 9001:2015 certified.",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Asati Ward No.1, Purana Thana Rd, Near SBI ATM",
              "addressLocality": "Damoh",
              "addressRegion": "Madhya Pradesh",
              "postalCode": "470661",
              "addressCountry": "IN"
            },
            "telephone": "+91-9131385180",
            "email": "shrikanttallyinstitute@gmail.com",
            "founder": {
              "@type": "Person",
              "name": "Shrikant Singhai"
            },
            "foundingDate": "2007",
            "hasMap": "https://www.google.com/maps/dir//Shrikant+tally+institute,+asati+ward+no.1,+Purana+Thana+Rd,+near+sbi+atm,+Damoh,+Madhya+Pradesh+470661",
            "sameAs": [
              "https://tallysolutions.com/partners/shree-enterprises/"
            ],
            "offers": {
              "@type": "Offer",
              "name": "Tally Professional Course",
              "description": "Industry-recognized Tally certification with placement support"
            }
          }
        `}</script>
      </Helmet>

      <Hero />
      <Services />
      <HowItWorks />
    </div>
  );
}

export default Main;
